import React, { useState, useEffect, useCallback } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import { getId, getRole } from "../../utils/helpers/custom";
import {
  profile,
  editProfile,
  editEmpHrProfile,
  adminProfile,
  editProfileImage,
  removeProfileImage,
} from "../../api/profileApi";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  digitRegex,
  InputPlaceHolder,
  SelectPlaceHolder,
  validationMessages,
} from "../../utils/helpers/validationMasseges";
import { listOfData } from "../../api/commonApi";
import {
  ResponseStatusEnum,
  nationality,
  religian,
  relation,
  GenderOption,
  NationalityOptions,
  ReligionOption,
  RelationOption,
} from "../../utils/helpers/enums";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import userDummyImg from "../../../src/assets/image/auth-one-bg.jpg";
import Loader from "../../components/common/loader";
import { EMPLOYEE_PROFILE_IMAGE } from "../../api/apiRoutes";
import { baseImageURL, baseURL } from "../../api/baseURL";
import ApproveRejectModal from "../../components/common/approveRejectModal";
import BaseInput from "../../components/BaseComponents/BaseInput";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import { checkStatusCodeSuccess, CommonLabel, onError, Roles } from "../../utils/helpers/common";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseModal from "../../components/BaseComponents/BaseModal";
import { EmployeeLabels } from "../../common/constant/Employee";
const EditProfile = (e) => {
  document.title = EmployeeLabels.UpdateProfile;
  const [fname, setfname] = useState("");
  const id = getId();
  // validation
  const [city, setCity] = useState([]);
  const [state, setState] = useState([]);
  const [country, setCountry] = useState([]);
  const [profileData, setProfile] = useState([]);
  const profileId = getId();
  const role = getRole();
  const [resUserDetails, setResUserDetails] = useState({});
  const [resbankdetails, setResBankDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [employeeAddressData, setEmployeeAddressData] = useState({});
  const [employeeAddressDetailData, setEmployeeAddressDetailData] = useState(
    {}
  );
  const [employeeAddressDetailData1, setEmployeeAddressDetailData1] = useState(
    {}
  );
  const [employeeAddressDetailData2, setEmployeeAddressDetailData2] = useState(
    {}
  );
  const [educationData, setEducationData] = useState({});
  const [emergencyContactData, setEmergencyContactNameData] = useState([]);
  const [modalTodo, setModalTodo] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletedImage, setDeletedImage] = useState();
  const navigate = useNavigate();

  const fetchData = () => {
    setLoading(true);
    listOfData({
      modelName: "cityModel",
      condition: {
        id: selectedState,
      },
    })
      .then((res) => {
        setCity(
          res?.data?.map((res) => ({
            value: res?.id,
            label: res?.cityName,
          }))
        );
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {});

    listOfData({
      modelName: "stateModel",
    })
      .then((res) => {
        setState(
          res?.data?.map((res) => ({
            value: res?.id,
            label: res?.stateName,
          }))
        );
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {});

    listOfData({
      modelName: "countryModel",
    })
      .then((res) => {
        setCountry(
          res?.data?.map((res) => ({
            value: res?.id,
            label: res?.countryName,
          }))
        );
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {});

    if (role === Roles.Admin) {
      adminProfile(profileId)
        .then((resp) => {
          setProfile(resp?.data);
          if (resp?.data?.userDetails === null) {
            setResUserDetails(null);
          } else {
            setResUserDetails(resp?.data?.userDetails);
          }
          if (resp?.data?.emergencyContact?.length === 0) {
            setEmergencyContactNameData(null);
          } else {
            setEmergencyContactNameData(resp?.data?.emergencyContact);
          }
          if (resp?.data?.address === null) {
            setEmployeeAddressData(null);
          } else {
            setEmployeeAddressData(resp?.data?.address);
            setEmployeeAddressDetailData(resp?.data?.address?.city);
            setEmployeeAddressDetailData1(resp?.data?.address?.state);
            setEmployeeAddressDetailData2(resp?.data?.address?.country);
          }
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
    } else {
      profile(profileId)
        .then((resp) => {
          if (resp?.data?.userDetails === null) {
            setResUserDetails(null);
          } else {
            setResUserDetails(resp?.data?.userDetails);
          }
          if (resp?.data?.bankDetails === null) {
            setResBankDetails(null);
          } else {
            setResBankDetails(resp?.data?.bankDetails);
          }
          if (resp?.data?.educationDetails === null) {
            setEducationData(null);
          } else {
            setEducationData(resp?.data?.educationDetails);
          }
          if (resp?.data?.emergencyContact?.length === 0) {
            setEmergencyContactNameData(null);
          } else {
            setEmergencyContactNameData(resp?.data?.emergencyContact);
          }
          if (resp?.data?.address === null) {
            setEmployeeAddressData(null);
          } else {
            setEmployeeAddressData(resp?.data?.address);
            setEmployeeAddressDetailData(resp?.data?.address.city);
            setEmployeeAddressDetailData1(resp?.data?.address.state);
            setEmployeeAddressDetailData2(resp?.data?.address.country);
          }
          setProfile(resp?.data);
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggle = useCallback(() => {
    if (modalTodo) {
      setModalTodo(false);
      // validation.resetForm();
    } else {
      setModalTodo(true);
    }
  }, [modalTodo]);

  const [newImage, setNewImage] = useState(null);
  const uploadImage = (e) => {
    if (role === Roles.Admin || role === Roles.HR || role === Roles.Employee) {
      setModalLoader(true);
      editProfileImage(profileId, e.target.files[0])
        .then((resp) => {
          if(checkStatusCodeSuccess(resp?.data?.statusCode)){
            toast.success(resp?.data?.message);
            navigate("/profile");
          } else {
            toast.error(resp?.data?.message);
          }
        })
        .catch((err) => err)
        .finally(() => {
          setModalLoader(false);
        });
    } else {
      setNewImage(e.target.files[0]);
    }
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const emailFormat =
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  const numberRegex = /^\d{10}$/;

  const createPhoneValidation = (fieldName) =>
    Yup.string()
      .required(validationMessages.required(fieldName))
      .matches(phoneRegExp, `${fieldName} is not valid`)
      .min(10, validationMessages.minLength(fieldName))
      .max(10, validationMessages.maxLength(fieldName));

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: profileData === null ? "" : profileData?.firstName || "",
      lastName: profileData === null ? "" : profileData?.lastName || "",
      email: profileData === null ? "" : profileData?.email || "",
      phoneNo: profileData === null ? "" : profileData?.phoneNo || "",
      gender: resUserDetails === null ? "" : resUserDetails?.gender || "",
      dob: resUserDetails === null ? "" : resUserDetails?.dob || "",
      religion:
        role === Roles.Admin
          ? ResponseStatusEnum.NO_DATA_FOUND
          : resUserDetails === null
          ? ""
          : resUserDetails?.religion || "",
      nationality:
        role === Roles.Admin
          ? ResponseStatusEnum.NO_DATA_FOUND
          : resUserDetails === null
          ? ""
          : resUserDetails?.nationality || "",
      personalEmail:
        resUserDetails === null ? "" : resUserDetails?.personalEmail || "",
      skypeId: resUserDetails === null ? "" : resUserDetails?.skypeId || "",
      addressLine1:
        employeeAddressData === null
          ? ""
          : employeeAddressData?.addressLine1 || "",
      addressLine2:
        employeeAddressData === null
          ? ""
          : employeeAddressData?.addressLine2 || "",
      cityId:
        role === Roles.Admin
          ? profileData?.address?.city?.id
          : employeeAddressData === null
          ? ""
          : employeeAddressDetailData?.id || "",
      stateId:
        role === Roles.Admin
          ? profileData?.address?.state?.id
          : employeeAddressData?.id === null
          ? ""
          : employeeAddressDetailData1?.id || "",
      countryId:
        role === Roles.Admin
          ? profileData?.address?.country?.id
          : employeeAddressData === null
          ? ""
          : employeeAddressDetailData2.id || null,
      primaryId: role !== Roles.Admin && emergencyContactData?.[0]?.id,
      primaryName:
        role === Roles.Admin
          ? ResponseStatusEnum.NO_DATA_FOUND
          : emergencyContactData === null
          ? null
          : emergencyContactData[0]?.name || null,
      primaryContactNo:
        role === Roles.Admin
          ? ResponseStatusEnum.NO_DATA_FOUND
          : emergencyContactData === null
          ? null
          : emergencyContactData?.[0]?.phoneNo || parseInt(""),
      primaryRelation:
        role === Roles.Admin
          ? ResponseStatusEnum.NO_DATA_FOUND
          : emergencyContactData === null
          ? null
          : emergencyContactData?.[0]?.relation || null,
      secondaryId: role !== Roles.Admin && emergencyContactData?.[1]?.id,
      secondaryName:
        role === Roles.Admin
          ? ResponseStatusEnum.NO_DATA_FOUND
          : emergencyContactData === null
          ? null
          : emergencyContactData?.[1]?.name || null,
      secondaryContactNo:
        role === Roles.Admin
          ? ResponseStatusEnum.NO_DATA_FOUND
          : emergencyContactData === null
          ? null
          : emergencyContactData[1]?.phoneNo || null,
      secondaryRelation:
        role === Roles.Admin
          ? ResponseStatusEnum.NO_DATA_FOUND
          : emergencyContactData === null
          ? null
          : emergencyContactData[1]?.relation || null,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required(validationMessages.required(EmployeeLabels.FirstName)),
      lastName: Yup.string().required(validationMessages.required(EmployeeLabels.LastName)),
      email: Yup.string()
        .required(validationMessages.required(EmployeeLabels.Email))
        .email("Email is not valid", emailFormat),
      phoneNo: Yup.string()
        .required(validationMessages.required(EmployeeLabels.PhoneNo))
        .matches(
          numberRegex,
          validationMessages.contactLength(EmployeeLabels.PhoneNo, 10)
        ),
      gender: Yup.string().required(validationMessages.required(EmployeeLabels.Gender)),
      dob: Yup.string().required(validationMessages.required(EmployeeLabels.DateOfBirth)),
      religion: Yup.string().required(validationMessages.required(EmployeeLabels.Religion)),
      nationality: Yup.string().required(validationMessages.required(EmployeeLabels.Nationality)),
      personalEmail: Yup.string()
        .required(validationMessages.required(EmployeeLabels.PersonalEmail))
        .email("Personal Email is not valid", emailFormat),
      skypeId: Yup.string()
        .required(validationMessages.required(EmployeeLabels.SkypeEmail))
        .email("Skype ID (Email) is not valid", emailFormat),
      addressLine1: Yup.string().required(validationMessages.required(EmployeeLabels.AddressLine1)),
      addressLine2: Yup.string().required(validationMessages.required(EmployeeLabels.AddressLine2)),
      cityId: Yup.string().required(validationMessages.required(EmployeeLabels.City)),
      stateId: Yup.string().required(validationMessages.required(EmployeeLabels.State)),
      countryId: Yup.string().required(validationMessages.required(EmployeeLabels.Country)),

      primaryContactNo:
        role !== Roles.Admin
          ? createPhoneValidation(EmployeeLabels.PrimaryContact)
          : Yup.string(),
      primaryName: Yup.string().required(validationMessages.required(EmployeeLabels.Name)),
      primaryRelation: Yup.string().required(validationMessages.required(EmployeeLabels.Relation)),
    }),
    onSubmit: (values) => {
      if (role === Roles.Admin) {
        if (newImage !== null) {
          setBtnLoader(true);
          editProfile(profileId, {
            user: {
              firstName: values.firstName,
              lastName: values.lastName,
              email: values.email,
              phoneNo: values.phoneNo,
            },
            userDetails: {
              gender: values.gender,
              dob: values.dob,
              personalEmail: values.personalEmail,
              skypeId: values.skypeId,
            },
            address: {
              addressLine1: values.addressLine1,
              addressLine2: values.addressLine2,
              cityId: parseInt(values.cityId),
              stateId: parseInt(values.stateId),
              countryId: parseInt(values.countryId),
            },
          })
            .then((resp) => {
              if(checkStatusCodeSuccess(resp?.data?.statusCode)){
                toast.success(resp?.data?.message);
                navigate("/profile");
              } else {
                toast.error(resp?.data?.message);
              }
            })
            .catch((err) => {
              return err;
            })
            .finally(() => {
              setBtnLoader(false);
            });
        } else {
          setBtnLoader(true);
          editProfile(profileId, {
            user: {
              firstName: values.firstName,
              lastName: values.lastName,
              email: values.email,
              phoneNo: values.phoneNo,
            },
            userDetails: {
              gender: values.gender,
              dob: values.dob,
              personalEmail: values.personalEmail,
              skypeId: values.skypeId,
            },
            address: {
              addressLine1: values.addressLine1,
              addressLine2: values.addressLine2,
              cityId: parseInt(values.cityId),
              stateId: parseInt(values.stateId),
              countryId: parseInt(values.countryId),
            },
          })
            .then((resp) => {
              if(checkStatusCodeSuccess(resp?.data?.statusCode)){
                toast.success(resp?.data?.message);
                navigate("/profile");
              } else {
                toast.error(resp?.data?.message);
              }
            })
            .catch((err) => {
              return err;
            })
            .finally(() => {
              setBtnLoader(false);
            });
        }
      } else {
        setBtnLoader(true);
        editEmpHrProfile(profileId, {
          user: {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            phoneNo: values.phoneNo,
          },
          userDetails: {
            gender: values.gender,
            dob: values.dob,
            profileImage: newImage,
            religion: values.religion,
            nationality: values.nationality,
            personalEmail: values.personalEmail,
            skypeId: values.skypeId,
          },
          address: {
            addressLine1: values.addressLine1,
            addressLine2: values.addressLine2,
            cityId: parseInt(values.cityId),
            stateId: parseInt(values.stateId),
            countryId: parseInt(values.countryId),
          },
          emergencyContacts: [
            {
              id: values.primaryId,
              name: values.primaryName,
              phoneNo: values.primaryContactNo,
              relation: values.primaryRelation,
            },
            values.secondaryId && values.secondaryName
            ? {
                id: values.secondaryId,
                name: values.secondaryName,
                phoneNo: values.secondaryContactNo,
                relation: values.secondaryRelation,
              }
            : null,
        ].filter(Boolean),
        })
          .then((resp) => {
            if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
              toast.success(resp?.data?.message);
              navigate("/profile");
            } else {
              toast.error(resp?.data?.message);
            }
          })
          .catch((err) => {
            return err;
          })
          .finally(() => {
            setBtnLoader(false);
          });
        validation.resetForm();
      }
    },
  });

  const [activeTab, setActiveTab] = useState("1");

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedState, setSelectedState] = useState();
  const handleCountryChange = (event) => {
    validation.setFieldValue("countryId", event.target.value);
    setSelectedCountry(event.target.value || validation.values.countryId);
  };
  const handleStateChange = (event) => {
    validation.setFieldValue("stateId", event.target.value);
    setSelectedState(event.target.value);
    listOfData({
      modelName: "cityModel",
      condition: {
        stateId: event.target.value,
      },
    })
      .then((res) => {
        setCity(
          res?.data?.map((res) => ({
            value: res?.id,
            label: res?.cityName,
          }))
        );

      })
      .catch((err) => {
        return err;
      })
      .finally(() => {});
  };

  const handleDelete = (row) => {
    setSelectedRow({ ...row, action: "to remove this image" });
    setDeletedImage(row);
    setDeleteModal(true);
  };

  const handleDeleteTodo = () => {
    setLoading(true);
    setDeleteModal(false);
    removeProfileImage(id, { oldImage: deletedImage })
      .then((res) => {
        if(checkStatusCodeSuccess(res?.data?.statusCode)){
          toast.success(res?.data?.message);
          navigate("/profile");
        } else {
          toast.err(res.data.message);
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <ApproveRejectModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
        loader={loading}
        action={selectedRow ? selectedRow.action : ""}
      />
      <div className="page-content">
        <Container fluid>
          <div className="position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg profile-setting-img">
              <img
                src={
                  profileData?.userDetails?.profileImage
                    ? `${baseImageURL}${profileData?.userDetails?.profileImage}`
                    : userDummyImg
                }
                onError={onError}
                className="profile-wid-img"
                alt=""
              />
            </div>
          </div>
          <Row>
            <Col xxl={3}>
              <Card className="mt-n5">
                <CardBody className="p-4">
                  {loading === false ? (
                    <div className="text-center">
                      <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                        <img
                          src={
                            profileData?.userDetails?.profileImage
                              ? `${baseImageURL}${profileData?.userDetails?.profileImage}`
                              : userDummyImg
                          }
                          onError={onError}
                          className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                          alt="user-profile"
                        />
                        <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                          <button
                            type="button"
                            className="btn profile-edit-img-file-input"
                            onClick={() => {
                              setModalTodo(true);
                            }}
                          >
                            <Label
                              htmlFor="profile-img-file-input"
                              className="profile-photo-edit avatar-xs"
                            >
                              <span className="avatar-title rounded-circle bg-light text-body">
                                <i className="ri-pencil-fill align-bottom" />
                              </span>
                            </Label>
                          </button>
                        </div>
                      </div>
                      <h5 className="fs-16 mb-1">{`${profileData?.firstName} ${profileData?.lastName}`}</h5>
                      <p className="text-muted mb-0">{role}</p>
                    </div>
                  ) : (
                    <Loader />
                  )}
                  </CardBody>
              </Card>
            </Col>
            <Col xxl={9}>
              <Card className="mt-xxl-n5">
                <CardBody className="p-4">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <CardHeader>
                            <h5>{EmployeeLabels.PersonalDetails}</h5>
                          </CardHeader>
                          <Col lg={6} className="pt-3 mb-3">
                            <BaseInput
                              name="firstName"
                              type="text"
                              placeholder={InputPlaceHolder(
                                EmployeeLabels.FirstName
                              )}
                              label={EmployeeLabels.FirstName}
                              onChange={validation.handleChange}
                              handleBlur={validation.handleBlur}
                              value={validation.values.firstName}
                              touched={validation.touched.firstName}
                              error={validation.errors.firstName}
                              required
                            />
                          </Col>
                          <Col lg={6} className="pt-3 mb-3">
                            <BaseInput
                              name="lastName"
                              type="text"
                              placeholder={InputPlaceHolder(
                                EmployeeLabels.LastName
                              )}
                              label={EmployeeLabels.LastName}
                              onChange={validation.handleChange}
                              handleBlur={validation.handleBlur}
                              value={validation.values.lastName}
                              touched={validation.touched.lastName}
                              error={validation.errors.lastName}
                              required
                            />
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <BaseInput
                                name="phoneNo"
                                type="text"
                                placeholder={InputPlaceHolder(
                                  EmployeeLabels.PhoneNo
                                )}
                                label={EmployeeLabels.PhoneNo}
                                onChange={(e) => {
                                  if (digitRegex.test(e.target.value)) {
                                    validation.handleChange(e);
                                  }
                                }}
                                handleBlur={validation.handleBlur}
                                value={validation.values.phoneNo}
                                touched={validation.touched.phoneNo}
                                error={validation.errors.phoneNo}
                                required
                                maxLength={10}
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <BaseInput
                                name="personalEmail"
                                type="email"
                                placeholder={InputPlaceHolder(
                                  EmployeeLabels.PersonalEmail
                                )}
                                label={EmployeeLabels.PersonalEmail}
                                onChange={validation.handleChange}
                                handleBlur={validation.handleBlur}
                                value={validation.values.personalEmail}
                                touched={validation.touched.personalEmail}
                                error={validation.errors.personalEmail}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <BaseSelect
                                name="gender"
                                label={EmployeeLabels.Gender}
                                options={GenderOption}
                                placeholder={SelectPlaceHolder(
                                  EmployeeLabels.Gender
                                )}
                                value={validation.values.gender}
                                handleChange={(field, value) => {
                                  validation.setFieldValue(field, value);
                                }}
                                handleBlur={validation.handleBlur}
                                error={validation.errors.gender}
                                touched={validation.touched.gender}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <Label
                                htmlFor="JoiningdatInput"
                                className="form-label required"
                              >
                                {EmployeeLabels.DateOfBirth}
                              </Label>
                              <Flatpickr
                                className={`form-control ${
                                  validation.errors.dob && "is-invalid"
                                }`}
                                id="datepicker-publish-input"
                                placeholder="Select a date"
                                name="dob"
                                validate={{ required: { value: true } }}
                                onBlur={validation.handleBlur}
                                value={validation.values.dob}
                                invalid={
                                  !!(
                                    validation.touched.dob &&
                                    validation.errors.dob
                                  )
                                }
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  maxDate: "today",
                                  onChange: function (
                                    selectedDates,
                                    dateStr,
                                    instance
                                  ) {
                                    validation
                                      .setFieldValue("dob", dateStr)
                                      .then((res) => res)
                                      .catch((err) => err);
                                  },
                                }}
                              />
                              <div className="invalid-feedback">
                                {validation.errors.dob}
                              </div>
                            </div>
                          </Col>
                          {role !== Roles.Admin && (
                            <>
                              <Col lg={4}>
                                <div className="mb-3">
                                  <BaseSelect
                                    name="nationality"
                                    label={EmployeeLabels.Nationality}
                                    options={NationalityOptions}
                                    placeholder={SelectPlaceHolder(
                                      EmployeeLabels.Nationality
                                    )}
                                    value={validation.values.nationality}
                                    handleChange={(field, value) => {
                                      validation.setFieldValue(field, value);
                                    }}
                                    handleBlur={validation.handleBlur}
                                    error={validation.errors.nationality}
                                    touched={validation.touched.nationality}
                                    required
                                  />
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="mb-3">
                                  <BaseSelect
                                    name="religion"
                                    label={EmployeeLabels.Religion}
                                    options={ReligionOption}
                                    placeholder={SelectPlaceHolder(
                                      EmployeeLabels.Religion
                                    )}
                                    value={validation.values.religion}
                                    handleChange={(field, value) => {
                                      validation.setFieldValue(field, value);
                                    }}
                                    handleBlur={validation.handleBlur}
                                    error={validation.errors.religion}
                                    touched={validation.touched.religion}
                                    required
                                  />
                                </div>
                              </Col>
                            </>
                          )}
                          <CardHeader>
                            <h5>{EmployeeLabels.AddressDetails}</h5>
                          </CardHeader>
                          <Col lg={6} className="pt-3">
                            <div className="mb-3">
                              <BaseInput
                                name="addressLine1"
                                type="text"
                                placeholder={InputPlaceHolder(
                                  EmployeeLabels.AddressLine1
                                )}
                                label={EmployeeLabels.AddressLine1}
                                onChange={validation.handleChange}
                                handleBlur={validation.handleBlur}
                                value={validation.values.addressLine1}
                                touched={validation.touched.addressLine1}
                                error={validation.errors.addressLine1}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={6} className="pt-3">
                            <div className="mb-3">
                              <BaseInput
                                name="addressLine2"
                                type="text"
                                placeholder={InputPlaceHolder(
                                  EmployeeLabels.AddressLine2
                                )}
                                label={EmployeeLabels.AddressLine2}
                                onChange={validation.handleChange}
                                handleBlur={validation.handleBlur}
                                value={validation.values.addressLine2}
                                touched={validation.touched.addressLine2}
                                error={validation.errors.addressLine2}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <BaseSelect
                                name="countryId"
                                options={country}
                                placeholder={SelectPlaceHolder(
                                  EmployeeLabels.Country
                                )}
                                label={EmployeeLabels.Country}
                                value={validation.values.countryId}
                                handleChange={(field, value) => {
                                  validation.setFieldValue(field, value);
                                }}
                                handleBlur={validation.handleBlur}
                                error={validation.errors.countryId}
                                touched={validation.touched.countryId}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <BaseSelect
                                name="stateId"
                                options={state}
                                placeholder={SelectPlaceHolder(
                                  EmployeeLabels.State
                                )}
                                label={EmployeeLabels.State}
                                value={validation.values.stateId}
                                handleChange={(field, value) => {
                                  validation.setFieldValue(field, value);
                                }}
                                handleBlur={validation.handleBlur}
                                error={validation.errors.stateId}
                                touched={validation.touched.stateId}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <BaseSelect
                                name="cityId"
                                options={city}
                                placeholder={SelectPlaceHolder(
                                  EmployeeLabels.City
                                )}
                                label={EmployeeLabels.City}
                                value={validation.values.cityId}
                                handleChange={(field, value) => {
                                  validation.setFieldValue(field, value);
                                }}
                                handleBlur={validation.handleBlur}
                                error={validation.errors.cityId}
                                touched={validation.touched.cityId}
                                required
                              />
                            </div>
                          </Col>
                          <CardHeader>
                            <h5>{EmployeeLabels.OfficeDetails}</h5>
                          </CardHeader>
                          <Col lg={6} className="pt-3">
                            <div className="mb-3">
                              <BaseInput
                                name="email"
                                type="text"
                                placeholder={InputPlaceHolder(
                                  EmployeeLabels.OfficialEmail
                                )}
                                label={EmployeeLabels.OfficialEmail}
                                onChange={validation.handleChange}
                                handleBlur={validation.handleBlur}
                                value={validation.values.email}
                                touched={validation.touched.email}
                                error={validation.errors.email}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={6} className="pt-3">
                            <div className="mb-3">
                              <BaseInput
                                name="skypeId"
                                type="text"
                                placeholder={InputPlaceHolder(
                                  EmployeeLabels.SkypeEmail
                                )}
                                label={EmployeeLabels.SkypeEmail}
                                onChange={validation.handleChange}
                                handleBlur={validation.handleBlur}
                                value={validation.values.skypeId}
                                touched={validation.touched.skypeId}
                                error={validation.errors.skypeId}
                                required
                              />
                            </div>
                          </Col>
                          {role !== Roles.Admin && (
                            <>
                              <CardHeader>
                                <h5>{EmployeeLabels.EmergencyDetails}</h5>
                              </CardHeader>
                              <label className="pt-2">
                                {EmployeeLabels.PrimaryEmergencyContact}
                              </label>
                              <Col lg={4} className="pt-3">
                                <div className="mb-3">
                                  <BaseInput
                                    name="primaryName"
                                    type="text"
                                    placeholder={InputPlaceHolder(
                                      EmployeeLabels.Name
                                    )}
                                    label={EmployeeLabels.Name}
                                    onChange={validation.handleChange}
                                    handleBlur={validation.handleBlur}
                                    value={validation.values.primaryName}
                                    touched={validation.touched.primaryName}
                                    error={validation.errors.primaryName}
                                    required
                                  />
                                </div>
                              </Col>
                              <Col lg={4} className="pt-3">
                                <div className="mb-3">
                                  <BaseSelect
                                    name="primaryRelation"
                                    options={RelationOption}
                                    placeholder={SelectPlaceHolder(
                                      EmployeeLabels.Relation
                                    )}
                                    label={EmployeeLabels.Relation}
                                    value={validation.values.primaryRelation}
                                    handleChange={(field, value) => {
                                      validation.setFieldValue(field, value);
                                    }}
                                    handleBlur={validation.handleBlur}
                                    error={validation.errors.primaryRelation}
                                    touched={validation.touched.primaryRelation}
                                    required
                                  />
                                </div>
                              </Col>
                              <Col lg={4} className="pt-3">
                                <div className="mb-3">
                                  <BaseInput
                                    name="primaryContactNo"
                                    type="text"
                                    placeholder={InputPlaceHolder(
                                      EmployeeLabels.PrimaryContact
                                    )}
                                    label={EmployeeLabels.PrimaryContact}
                                    onChange={(e) => {
                                      if (digitRegex.test(e.target.value)) {
                                        validation.handleChange(e);
                                      }
                                    }}
                                    handleBlur={validation.handleBlur}
                                    value={validation.values.primaryContactNo}
                                    touched={
                                      validation.touched.primaryContactNo
                                    }
                                    error={validation.errors.primaryContactNo}
                                    required
                                    maxLength={10}
                                  />
                                </div>
                              </Col>

                              <label className="pt-2">
                                {EmployeeLabels.SecondaryEmergencyContact}
                              </label>
                              <Col lg={4} className="pt-3">
                                <div className="mb-3">
                                  <BaseInput
                                    name="secondaryName"
                                    type="text"
                                    placeholder={InputPlaceHolder(
                                      EmployeeLabels.Name
                                    )}
                                    label={EmployeeLabels.Name}
                                    onChange={validation.handleChange}
                                    handleBlur={validation.handleBlur}
                                    value={validation.values.secondaryName}
                                    touched={validation.touched.secondaryName}
                                    error={validation.errors.secondaryName}
                                  />
                                </div>
                              </Col>
                              <Col lg={4} className="pt-3">
                                <div className="mb-3">
                                  <BaseSelect
                                    name="secondaryRelation"
                                    options={RelationOption}
                                    placeholder={SelectPlaceHolder(
                                      EmployeeLabels.Relation
                                    )}
                                    label={EmployeeLabels.Relation}
                                    value={validation.values.secondaryRelation}
                                    handleChange={(field, value) => {
                                      validation.setFieldValue(field, value);
                                    }}
                                    handleBlur={validation.handleBlur}
                                    error={validation.errors.secondaryRelation}
                                    touched={
                                      validation.touched.secondaryRelation
                                    }
                                  />
                                </div>
                              </Col>
                              <Col lg={4} className="pt-3">
                                <div className="mb-3">
                                  <BaseInput
                                    name="secondaryContactNo"
                                    type="text"
                                    placeholder={InputPlaceHolder(
                                      EmployeeLabels.SecondaryContact
                                    )}
                                    label={EmployeeLabels.SecondaryContact}
                                    onChange={(e) => {
                                      if (digitRegex.test(e.target.value)) {
                                        validation.handleChange(e);
                                      }
                                    }}
                                    handleBlur={validation.handleBlur}
                                    value={validation.values.secondaryContactNo}
                                    touched={
                                      validation.touched.secondaryContactNo
                                    }
                                    error={validation.errors.secondaryContactNo}
                                    maxLength={10}
                                  />
                                </div>
                              </Col>
                            </>
                          )}
                          <Col lg={12}>
                            <div className="hstack gap-2 justify-content-end">
                              <BaseButton
                                color="primary"
                                type="submit"
                                label={CommonLabel.Update}
                                loader={btnLoader}
                                className="w-100"
                              />
                              <BaseButton
                                color="soft-success"
                                type="button"
                                label={CommonLabel.Cancel}
                                onClick={() => {
                                  navigate("/profile");
                                }}
                                className="w-100"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <BaseModal
            open={modalTodo}
            onClose={() => setModalTodo(false)}
            toggle={toggle}
            className="zoomIn"
            title="Profile Photo"
            bodyClassName="p-4"
            submit={() => validation.handleSubmit()}
            closeLabel={CommonLabel.Close}
            submitLabel={CommonLabel.Submit}
            closeLabelColor="ghost-success"
            submitLabelColor="primary"
          >
            <div id="task-error-msg" className="alert alert-danger py-2"></div>
            <Form
              id="creattask-form"
              className="relative-container"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              {modalLoader && <Loader />}
              <input type="hidden" id="taskid-input" className="form-control" />

              <div className="p-4 card-body">
                <div className="text-center">
                  <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                    <img
                      className="img-thumbnail user-profile-image"
                      onError={onError}
                      alt="Avatar"
                      width="200"
                      src={
                        profileData?.userDetails?.profileImage
                          ? `${baseImageURL}${profileData?.userDetails?.profileImage}`
                          : userDummyImg
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="flex-grow-1 row">
                <div className="col-sm-1 ms-2 fs-2">
                  <i className="ri-checkbox-circle-fill text-success"></i>
                </div>
                <div className="col-sm-2 ms-1 fs-2">File :</div>
                <div className="col-sm-5 ms-2">
                  <Input
                    accept=".png, .jpg, .jpeg"
                    type="file"
                    onChange={(e) => uploadImage(e)}
                  />
                </div>
                <div className="col-sm-1"></div>
                {profileData?.userDetails?.profileImage && (
                  <div className="col-sm-2 ms-2">
                    <BaseButton
                      type="button"
                      color="danger"
                      onClick={() =>
                        handleDelete(profileData?.userDetails?.profileImage)
                      }
                    >
                      <i className="ri-close-circle-line"></i>
                    </BaseButton>
                  </div>
                )}
              </div>
            </Form>
          </BaseModal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditProfile;
